<template>
  <GenericInfo api-endpoint="audit" :type="type">
    <template v-slot:title>
      <h1>{{ $t('auditInformation') }}</h1>
    </template>
    <template v-slot:info>
      <div class="input-group-add">
        <label class="audit-label">{{ $t('operation') }}:</label>
        <input type="text" class="input-add" :value="item.operation_type" :disabled="true" />
      </div>
      <div class="input-group-add">
        <label class="audit-label">{{ $t('table') }}:</label>
        <input type="text" class="input-add" :value="item.table_name" :disabled="true" />
      </div>
      <div class="input-group-add">
        <label class="audit-label">{{ $t('command') }}:</label>
        <textarea class="input-add" :value="item.operation_details" disabled rows="5" />
      </div>
      <div class="input-group-add">
        <label class="audit-label">{{ $t('operator') }}:</label>
        <input type="text" class="input-add" :value="item.user_name" :disabled="true" />
      </div>
      <div class="input-group-add">
        <label class="audit-label">{{ $t('operationTime') }}:</label>
        <input type="text" class="input-add" :value="item.operation_time" :disabled="true" />
      </div>
    </template>
  </GenericInfo>
</template>

<script>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ref, onMounted, inject } from 'vue';
import { fetchData } from '../utils/api';
import GenericInfo from '../generic/GenericInfo.vue';

export default {
  components: {
    GenericInfo,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const page = ref('audit');
    const btnLabel = ref(t('add'));
    const apiBaseUrl = inject('apiBaseUrl');
    const id = ref(0);
    const item = ref('');
    const route = useRoute();
    if (props.type !== 0) {
      onMounted(async () => {
        id.value = route.params.id;
        fetchData(t, `${apiBaseUrl}/info/${page.value}`, id.value).then((response) => {
          if (response.data) {
            item.value = response.data.result;
          }
        });
      });
    }
    return {
      t,
      page,
      btnLabel,
      apiBaseUrl,
      id,
      item,
    };
  },
  methods: {},
};
</script>
<style>
.audit-label {
  flex: 0.2;
  text-align: left;
  margin-right: 10px;
  font-size: 20px;
}

.audit-info {
  flex: 0.8;
  text-align: left;
  margin-right: 10px;
  font-size: 20px;
}
</style>
